var $5e4abb947f3a742c$exports = {};
$5e4abb947f3a742c$exports = {
    "loading": `Carregando...`,
    "loadingMore": `Carregando mais...`
};


export {$5e4abb947f3a742c$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
